import React from 'react'
// from: https://usehooks.com/useOnClickOutside/

const APP_HTML_IGNORE_NODE = 'HTML'
const CLASSES_TO_IGNORE = ['rc-tooltip', 'vcp-context-menu', 'vcp-dropdown-select-rc']

function useOnClickOutside(
  ref: React.MutableRefObject<HTMLElement | undefined | null>,
  handler: any,
  dataIdsToIgnoreClickOutside: string[] = [],
  disabled = false,
  ignoreDefaultClasses = true
) {
  React.useEffect(() => {

    const listener = (event: any) => {
      if (disabled) {
        return
      }
      if (event.type === 'blur') {
        return handler(event)
      }
      const target = event.target

      if (!target || !ref) {
        return
      }

      const clickedInside = ref.current?.contains(target)

      if (clickedInside) {
        return
      }

      let element = target

      while (element) {
        const dataId = element.dataset && element.dataset.id
        const dataTypeId = element.dataset && element.dataset.typeId

        const shouldIgnoreClickOutside =
        (dataTypeId && dataIdsToIgnoreClickOutside.includes(dataTypeId)) ||
        (dataId && dataIdsToIgnoreClickOutside.includes(dataId)) ||
        // eslint-disable-next-line no-loop-func
        (ignoreDefaultClasses && CLASSES_TO_IGNORE.some(classToIgnore => element.classList?.contains(classToIgnore)))

        if (shouldIgnoreClickOutside) {
          return
        }

        element = element.parentNode

        if (element && element.nodeName === APP_HTML_IGNORE_NODE) {
          element = null
        }
      }

      handler(event)
    }

    document.addEventListener('mousedown', listener, true)
    document.addEventListener('touchstart', listener, true)

    return () => {
      document.removeEventListener('mousedown', listener, true)
      document.removeEventListener('touchstart', listener, true)
    }
  },
  // Add ref and handler to effect dependencies
  // It's worth noting that because passed in handler is a new
  // function on every render that will cause this effect
  // callback/cleanup to run every render. It's not a big deal
  // but to optimize you can wrap handler in useCallback before
  // passing it into this hook.
  [ref, handler, dataIdsToIgnoreClickOutside, disabled])
}

export default useOnClickOutside